import styled from 'styled-components';
import { Link } from 'ui/links';
import { pxToRem } from 'utils/convert';
import { body2, Body2, Caption, caption, colors, fontWeights, spacing } from 'ui/theme';
import { FlexSpacer } from 'ui/flexSpacer';
import { IconButton } from 'ui/button';
import { TruncateTooltip } from 'ui/utility/truncate/TruncateTooltip';

export const SecondaryBody2 = styled(Body2)`
  margin: 0;
  color: ${colors.textSecondary};
`;

export const MessageTypeName = styled(Body2)`
  margin: 0;
`;

export const ArrowButton = styled(IconButton)`
  cursor: pointer;
  flex: 0 0 auto;
`;

export const CampaignsTextFlex = styled(FlexSpacer)`
  margin-top: ${spacing.plusQuarter};
`;

export const CampaignRow = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(42)} 1fr;
  grid-template-rows: 1fr;
  gap: ${spacing.quarter} ${spacing.half};
  align-items: center;
`;

export const CampaignThumbnailContainer = styled.div`
  grid-area: 1 / 1;
`;
export const CampaignInfoContainer = styled.div`
  grid-area: 1 / 2;

  & a > span {
    display: grid;
  }
`;
export const CampaignInfoIdDetails = styled(Caption)`
  color: ${colors.textSecondary};
`;
export const CampaignInfoIdDetailsContent = styled.span`
  ${caption};
  color: ${colors.textSecondary};

  &::before {
    color: ${colors.grey25};
    content: '\\2219';
    margin-right: ${spacing.quarter};
    margin-left: ${spacing.quarter};
    font-weight: ${fontWeights.semiBold};
  }
`;

export const StyledLink = styled(Link)`
  color: ${colors.textPrimary};
  text-decoration: none;
  display: inline;

  &:hover {
    color: ${colors.textInteractiveHover};
  }
`;

export const StyledTruncatedText = styled(TruncateTooltip)`
  ${body2};

  &:hover {
    color: ${colors.textInteractiveHover};
  }
`;

export const CampaignImg = styled.img`
  border-radius: ${spacing.eighth};
  border: 1px solid ${colors.borderPrimary};
`;
